import React, { useEffect, useState } from "react";
import SettingModalButton from "../SettingModalButton/SettingModalButton";
import SettingModalRedButton from "../SettingModalRedButton/SettingModalRedButton";

const SettingPermitModal = ({
  userType1,
  data,
  getFamilyMemberImageFrom,
  isToggleDisable,
  type,
  onClose,
  image,
  userName,
  userType,
  toggle,
  allMembersImagedata,
}) => {
  const [isNotification, setIsNotification] = useState("");
  useEffect(() => {
    type !== "notification"
      ? setIsNotification("access")
      : setIsNotification("notification");
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className={
        type === "notification"
          ? "permit_modal_outer"
          : data?.length !== 1
          ? "permit_modal_outer padding_btm50"
          : "permit_modal_outer padding_btm16"
      }
    >
      {userType1 === "All" &&
        (allMembersImagedata?.length > 1 ? (
          <div
            className="img_holder"
            style={{ width: allMembersImagedata?.length * 34 + "px" }}
          >
            {allMembersImagedata?.map((dat, index) => {
              return dat?.image !== undefined ? (
                <img
                  className="img_size"
                  style={
                    index !== 0
                      ? {
                          position: "absolute",
                          left: index * 34 + "px",
                          zIndex: index - 1 < 0 ? 0 : index - 1,
                          width: "41px",
                          height: "41px",
                        }
                      : {
                          position: "relative",
                          zIndex: data?.length < 0 ? 0 : data?.length,
                          width: "41px",
                          height: "41px",
                        }
                  }
                  src={dat.image}
                  alt="profile"
                />
              ) : (
                <div
                  className="no_img"
                  style={{
                    left: index * 34 + "px",
                    zIndex: index - 1 < 0 ? 0 : index - 1,
                  }}
                >
                  {dat?.title?.split(" ")[0][0]}
                  {dat?.title?.slice(dat?.title?.lastIndexOf(" ") + 1)[0]}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="img_holder" style={{ width: "75px", height: "75px" }}>
            {allMembersImagedata?.map((dat, index) => {
              return dat?.image !== undefined ? (
                <img
                  className="img_size"
                  style={
                    index !== 0
                      ? {
                          width: "75px",
                          height: "75px",
                          borderRadius: "34px 34px 33px 33px",
                          objectFit: "cover",
                        }
                      : {
                          width: "75px",
                          height: "75px",
                          borderRadius: "34px 34px 33px 33px",
                          objectFit: "cover",
                        }
                  }
                  src={dat.image}
                  alt="profile"
                />
              ) : (
                <div
                  className="no_img"
                  style={{
                    left: index * 34 + "px",
                    zIndex: index - 1 < 0 ? 0 : index - 1,
                  }}
                >
                  {dat?.title?.split(" ")[0][0]}
                  {dat?.title?.slice(dat?.title?.lastIndexOf(" ") + 1)[0]}
                </div>
              );
            })}
          </div>
        ))}
      {type === "notification" ? (
        <img src={image} alt="type" />
      ) : data?.length === 1 &&
        userType1 !== "All" &&
        data[0].client.profile_pic ? (
        <img
          style={{
            height: "75px",
            width: "75px",
            borderRadius: "34px 34px 33px 33px",
            objectFit: "cover",
          }}
          src={getFamilyMemberImageFrom[data[0].client.user_id]}
          alt="user"
        />
      ) : data?.length === 1 &&
        userType1 !== "All" &&
        !data[0].client.profile_pic ? (
        <div className="single_no_image">
          <p>{data[0].client.full_name.split(" ")[0][0]}</p>
        </div>
      ) : (
        ""
      )}
      <h2
        className={
          type === "notification"
            ? "permit_heading margin15"
            : "permit_heading margin10"
        }
      >
        {isToggleDisable ? "Enable" : "Disable"} {/* {isEnable} */}
        {type === "notification"
          ? "Notifications"
          : data?.length === 1 && userType1 !== "All"
          ? `${data[0].client.full_name}'s access`
          : "all family members access"}
        ?
      </h2>
      <h6 className="permit_msg">
        You can always{" "}
        {type === "notification"
          ? "enable"
          : isToggleDisable
          ? "Disable"
          : "Enable"}{" "}
        {type === "notification"
          ? "notifications"
          : data?.length === 1 && userType1 !== "All"
          ? `access for ${data[0].client.full_name || null}`
          : `access for all family`}{" "}
        later from {userType} settings
      </h6>
      <div
        className={
          type !== "notification"
            ? "permit_btn_div marginbtn45"
            : "permit_btn_div marginbtn40"
        }
      >
        <h2 className="cancel_btn" onClick={onClose}>
          Cancel
        </h2>
        <h2 className="permit_permission">
          {isToggleDisable ? (
            <SettingModalButton
              label={"Yes, Enable"}
              toggle={() => toggle(data)}
              isNotification={isNotification}
            />
          ) : (
            <SettingModalRedButton
              label={"Yes, Disable"}
              toggle={() => toggle(data)}
            />
          )}
        </h2>
      </div>
    </div>
  );
};

export default SettingPermitModal;
